import { useCallback, useMemo } from 'react';

import { ConsumerBackerIntent } from '@givebacks/api/backer';

import { NavigationIntents } from '../../types/onboarding';

/**
 * Determines which UI sections should be navigable
 */
export const useIntentNavigation = (fetchedIntents: ConsumerBackerIntent): NavigationIntents => {
  //Determine if the user has cause actions
  const hasCauseActions = useCallback((intents: ConsumerBackerIntent): boolean => {
    return (
      (intents.buy_a_membership ?? false) ||
      (intents.support_a_fundraiser ?? false) ||
      (intents.buy_a_store_item ?? false) ||
      (intents.buy_a_ticket ?? false) ||
      (intents.make_a_donation ?? false)
    );
  }, []);

  const hasAccountActions = useCallback((intents: ConsumerBackerIntent): boolean => {
    return (intents.view_membership_card ?? false) || (intents.view_event_tickets ?? false);
  }, []);

  //Return the navigation intents
  return useMemo(
    (): NavigationIntents => ({
      visitAccount: hasAccountActions(fetchedIntents),
      visitCause: hasCauseActions(fetchedIntents),
      visitFees: fetchedIntents.pay_a_student_fee ?? false,
      visitRewards: fetchedIntents.check_out_shop_to_give ?? false,
      visitPurchases: fetchedIntents.view_purchase_history ?? false,
      visitRewardsActivity: fetchedIntents.view_cash_back_earned ?? false,
    }),
    [fetchedIntents, hasAccountActions, hasCauseActions]
  );
};
